import { RefObject, useLayoutEffect, useRef, useState } from 'react';

export interface ScrollEndGate {
  scrollRef: RefObject<HTMLDivElement>;
  hasReachedEnd: boolean;
  onScroll: () => void;
}

const SCROLL_END_THRESHOLD_PX = 8;

const isScrolledToEnd = (element: HTMLDivElement): boolean => {
  return (
    element.scrollTop + element.clientHeight >=
    element.scrollHeight - SCROLL_END_THRESHOLD_PX
  );
};

export const useScrollEndGate = (): ScrollEndGate => {
  const scrollRef = useRef<HTMLDivElement>(null);
  const [hasReachedEnd, setHasReachedEnd] = useState(false);

  const onScroll = (): void => {
    const element = scrollRef.current;

    if (!element) {
      return;
    }

    if (isScrolledToEnd(element)) {
      setHasReachedEnd(true);
    }
  };

  useLayoutEffect(() => {
    const markReachedEndWhenContentDoesNotOverflow = (): void => {
      const element = scrollRef.current;

      if (!element) {
        return;
      }

      if (isScrolledToEnd(element)) {
        setHasReachedEnd(true);
      }
    };

    markReachedEndWhenContentDoesNotOverflow();
  }, []);

  return { scrollRef, hasReachedEnd, onScroll };
};